import React from 'react';
import { AlertCircle } from 'lucide-react';

const ErrorState = ({ message, onRetry }) => (
  <div className="flex items-center justify-center h-96">
    <div className="text-center">
      <AlertCircle className="h-8 w-8 text-red-500 mx-auto mb-4" />
      <div className="text-red-500 text-lg font-medium mb-2">Error Loading Data</div>
      <div className="text-gray-600 text-sm mb-4">{message}</div>
      <button
        onClick={onRetry}
        className="btn-primary"
      >
        Retry
      </button>
    </div>
  </div>
);

export default ErrorState;
